<template>
    <div>
        <h2>Proxies</h2>

        <div class="container text-right">
            <small>
                These actions apply to all of your proxies. Not only the one
                which are listed below!
            </small>
            <p>
                <button class="btn btn-dark" @click="enableAllAccount">
                    Enable All
                </button>
                <button
                    class="btn btn-secondary text-white btn-margin"
                    @click="disableAllAccount"
                >
                    Disable All
                </button>
                <button
                    class="btn btn-danger btn-margin"
                    @click="confirm(null, deleteAllAccount)"
                >
                    Delete All
                </button>
            </p>
        </div>

        <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Details</th>
                        <th>Quota</th>
                        <th>Action</th>
                        <th />
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(account, i) in accounts" :key="account.id">
                        <td>{{ i + 1 }}</td>
                        <td>
                            <div class="form-group">
                                <small>Username</small>
                                <div class="input-group input-group-sm">
                                    <input
                                        v-model="account.id"
                                        type="text"
                                        class="form-control"
                                        disabled="disabled"
                                    />
                                </div>
                            </div>

                            <div class="form-group">
                                <small>Password</small>
                                <div class="input-group input-group-sm">
                                    <input
                                        v-model="account.password"
                                        :disabled="loading"
                                        class="form-control"
                                        type="text"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            :disabled="loading"
                                            class="btn btn-dark"
                                            type="button"
                                            @click="changePassword(i)"
                                        >
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="form-group">
                                <small>Quota</small>
                                <div class="input-group input-group-sm">
                                    <select
                                        v-model="account.quota"
                                        :disabled="loading"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="quotaOpt in quotaOpts"
                                            :key="quotaOpt.value"
                                            :value="quotaOpt.value"
                                        >
                                            {{ quotaOpt.label }}
                                        </option>
                                    </select>
                                    <div class="input-group-append">
                                        <button
                                            :disabled="loading"
                                            class="btn btn-dark"
                                            type="button"
                                            @click="changeQuota(i)"
                                        >
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <small>Usage</small>
                                <div class="input-group input-group-sm">
                                    <input
                                        :value="account.usage | prettyBytes"
                                        type="text"
                                        class="form-control"
                                        disabled="disabled"
                                    />
                                    <div class="input-group-append">
                                        <button
                                            :disabled="loading"
                                            class="btn btn-dark"
                                            type="button"
                                            @click="confirm(i, resetUsage)"
                                        >
                                            Reset
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <div class="form-group">
                                <small>Region</small>
                                <div class="input-group input-group-sm">
                                    <select
                                        v-model="account.region"
                                        :disabled="loading"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="country in countries"
                                            :key="country.code"
                                            :value="country.code"
                                        >
                                            {{ country.name }}
                                        </option>
                                    </select>
                                    <div class="input-group-append">
                                        <button
                                            :disabled="loading"
                                            class="btn btn-dark"
                                            type="button"
                                            @click="changeRegionOrSticky(i)"
                                        >
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group">
                                <small>Sticky</small>
                                <div class="input-group input-group-sm">
                                    <select
                                        v-model="account.sticky"
                                        :disabled="loading"
                                        class="form-control"
                                    >
                                        <option
                                            v-for="stickyOpt in stickyOpts"
                                            :key="stickyOpt.value"
                                            :value="stickyOpt.value"
                                        >
                                            {{ stickyOpt.label }}
                                        </option>
                                    </select>
                                    <div class="input-group-append">
                                        <button
                                            :disabled="loading"
                                            class="btn btn-dark"
                                            type="button"
                                            @click="changeRegionOrSticky(i)"
                                        >
                                            Change
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                        <td>
                            <button
                                :disabled="loading"
                                class="btn btn-sm btn-danger btn-block"
                                @click="confirm(i, deleteAccount)"
                            >
                                Delete
                            </button>

                            <button
                                v-if="account.disabled"
                                :disabled="loading"
                                class="btn btn-sm btn-dark btn-block text-white"
                                @click="enableAccount(i)"
                            >
                                Enable
                            </button>
                            <button
                                v-else
                                :disabled="loading"
                                class="btn btn-sm btn-secondary btn-block text-white"
                                @click="disableAccount(i)"
                            >
                                Disable
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <div class="container">
            <p class="text-center">
                <button
                    v-if="!noMore"
                    class="btn btn-secondary btn-block"
                    @click="getAccounts()"
                >
                    Load more
                </button>
            </p>
        </div>
    </div>
</template>

<script>
import superagent from 'superagent'
import prettyBytes from 'pretty-bytes'
import swal from 'sweetalert'

import { eventBus } from '../events'
import { config, auth, proxy, response, ad } from 'website-core'

export default {
    filters: {
        prettyBytes(bytes) {
            return prettyBytes(bytes)
        },
    },
    data() {
        return {
            quotaOpts: proxy.quotas,
            countries: null,
            stickyOpts: proxy.stickies,

            accounts: [],
            noMore: false,
            loading: false,
        }
    },
    async created() {
        this.countries = await ad.region.get()

        this.getAccounts()

        // listen to new account from new account component
        eventBus.$on('newAccount', _account => {
            this.accounts.unshift({
                id: _account.username,
                password: _account.password,
                quota: _account.quota,
                region: _account.region,
                sticky: _account.sticky,
                usage: 0,
                disabled: false,
            })
        })
    },
    methods: {
        getAccounts() {
            var self = this

            self.loading = true
            superagent
                .get(config.url_api + '/account')
                .query(auth.getAuthQs())
                .query({ skip: this.accounts.length })
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200 || !res.body) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    if (res.body.length === 0) {
                        self.noMore = true
                        return
                    }

                    let accounts = res.body

                    self.accounts.push(...accounts)
                    return
                })
        },
        changePassword(i) {
            var self = this

            self.loading = true
            superagent
                .put(
                    config.url_api + '/account/password/' + self.accounts[i].id
                )
                .type('form')
                .query(auth.getAuthQs())
                .send({ password: self.accounts[i].password })
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        disableAccount(i) {
            var self = this

            self.loading = true
            superagent
                .put(config.url_api + '/account/disable/' + self.accounts[i].id)
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.accounts[i].disabled = true
                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        disableAllAccount() {
            var self = this

            self.loading = true
            superagent
                .put(config.url_api + '/account/disable')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    for (let i = 0; i < self.accounts.length; i++) {
                        self.accounts[i].disabled = true
                    }

                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        enableAccount(i) {
            var self = this

            self.loading = true
            superagent
                .put(config.url_api + '/account/enable/' + self.accounts[i].id)
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.accounts[i].disabled = false
                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        enableAllAccount() {
            var self = this

            self.loading = true
            superagent
                .put(config.url_api + '/account/enable')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    for (let i = 0; i < self.accounts.length; i++) {
                        self.accounts[i].disabled = false
                    }

                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        deleteAccount(i) {
            var self = this

            self.loading = true
            superagent
                .del(config.url_api + '/account/' + self.accounts[i].id)
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.accounts.splice(i, 1)
                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        deleteAllAccount() {
            var self = this

            self.loading = true
            superagent
                .del(config.url_api + '/account')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.accounts = []

                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        changeQuota(i) {
            var self = this

            self.loading = true
            superagent
                .put(config.url_api + '/account/quota/' + self.accounts[i].id)
                .type('form')
                .query(auth.getAuthQs())
                .send({ quota: self.accounts[i].quota })
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        changeRegionOrSticky(i) {
            var self = this

            self.loading = true
            superagent
                .put(
                    config.url_api +
                        '/account/region_sticky/' +
                        self.accounts[i].id
                )
                .type('form')
                .query(auth.getAuthQs())
                .send({ region: self.accounts[i].region })
                .send({ sticky: self.accounts[i].sticky })
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
        confirm(i, callback) {
            swal('Are you sure?', {
                dangerMode: true,
                buttons: true,
            }).then(value => {
                if (value) {
                    callback(i)
                }
            })
        },
        resetUsage(i) {
            var self = this

            self.loading = true
            superagent
                .put(config.url_api + '/account/reset/' + self.accounts[i].id)
                .type('form')
                .query(auth.getAuthQs())
                .end(function(err, res) {
                    self.loading = false

                    if (
                        response.ResHandle(
                            err,
                            res,
                            function() {},
                            self.$router
                        )
                    ) {
                        return
                    }

                    if (res.status != 200) {
                        response.ResShowErr(
                            'There was an unknown error. Please try again later'
                        )
                        return
                    }

                    self.accounts[i].usage = 0
                    response.ResShowOK(
                        'Please wait 1-2 min for all servers to sync new update'
                    )
                    return
                })
        },
    },
}
</script>